import { pickBy } from 'lodash';
import { Channel } from 'redux-saga';
import ISocketHandler from '../../../../api/sockets/ISocketHandler';
import ISocketMessage from '../../../../api/sockets/ISocketMessage';
import checkNullableValue from '../../../../utils/checkNullableValue';
import { serializeTask } from '../../../serializers/tasks';
import {
  WS_ADD_TASK_IN_LIST,
  WS_DELETE_TASK_FROM_LIST,
  WS_UPDATE_TASK_IN_LIST,
} from '../../../actions/tasks';

class TaskChannelHandler implements ISocketHandler {
  socketChannel: Channel<Record<string, unknown>>;

  constructor(channel: Channel<Record<string, unknown>>) {
    this.socketChannel = channel;
  }

  update(message: ISocketMessage): void {
    const task = serializeTask(message.data);
    const updatedTaskFields = pickBy(task, checkNullableValue);

    this.socketChannel.put({
      type: WS_UPDATE_TASK_IN_LIST,
      payload: { task: updatedTaskFields },
    });
  }

  create(message: ISocketMessage): void {
    const task = serializeTask(message.data);

    this.socketChannel.put({
      type: WS_ADD_TASK_IN_LIST,
      payload: { task },
    });
  }

  delete(message: ISocketMessage): void {
    const task = serializeTask(message.data);

    this.socketChannel.put({
      type: WS_DELETE_TASK_FROM_LIST,
      payload: { taskId: task.id },
    });
  }
  info(): void {
    return undefined;
  }
}

export default TaskChannelHandler;
